import { render, staticRenderFns } from "./delete-all.vue?vue&type=template&id=0365989b"
import script from "./delete-all.vue?vue&type=script&lang=js"
export * from "./delete-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports